import { Howl, Howler } from 'howler';

const effects = ['ui-tap', 'collect', 'build', 'upgrade', 'summon', 'deploy', 'attack', 'hit', 'defeat', 'victory', 'stamp'];
const bank = Object.fromEntries(effects.map(name => [name, new Howl({ src: [`/audio/${name}.wav`], volume: name === 'ui-tap' ? .28 : .58, preload: false })]));
const ambience = new Howl({ src: ['/audio/ambience.wav'], loop: true, volume: .16, preload: false });
const music = new Howl({ src: ['/audio/music.wav'], loop: true, volume: .11, preload: false });
let unlocked = false;
let muted = localStorage.getItem('clash-muted') === '1';

Howler.mute(muted);

function unlock() {
  if (unlocked) return;
  unlocked = true;
  ambience.play();
  music.play();
}

export const sound = {
  play(name) {
    unlock();
    bank[name]?.play();
  },
  unlock,
  toggle() {
    muted = !muted;
    Howler.mute(muted);
    localStorage.setItem('clash-muted', muted ? '1' : '0');
    if (!muted) unlock();
    return muted;
  },
  get muted() { return muted; }
};
